import { render, staticRenderFns } from "./ScreenObstetricaDoppler.vue?vue&type=template&id=397278ba&scoped=true&"
import script from "./ScreenObstetricaDoppler.vue?vue&type=script&lang=js&"
export * from "./ScreenObstetricaDoppler.vue?vue&type=script&lang=js&"
import style0 from "./ScreenObstetricaDoppler.vue?vue&type=style&index=0&id=397278ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397278ba",
  null
  
)

export default component.exports